module.exports = __webpack_public_path__ + "img/atari1200_rear.7ac74203.jpg";